import {observer} from "mobx-react";
import {IJackpotBetWinInfo} from "../../../jackpot-bet-live-win-highlight/interfaces/jackpot-bet-win-info.interface";
import {OptInWinHighlightBox} from "./boxes/opt-in-win-highlight.box";

interface OptInWinHighlightProps {
    jackpotBetWinInfo: IJackpotBetWinInfo;
}
export const OptInWinHighlightComponent: React.FC<OptInWinHighlightProps> = observer((props) => {
    return (<OptInWinHighlightBox>
        {props.jackpotBetWinInfo.render()}
    </OptInWinHighlightBox>)
});